Array.prototype.nonEmpty = function () {
    return this.length > 0;
};
